/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Sync_FailedInputs */

const en_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project sync failed: ${i?.message}`)
};

const fr_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la synchronisation du projet : ${i?.message}`)
};

const de_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projektsynchronisierung fehlgeschlagen: ${i?.message}`)
};

const it_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sincronizzazione del progetto non riuscita: ${i?.message}`)
};

const ru_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Синхронизация проекта не удалась: ${i?.message}`)
};

const es_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error de sincronización del proyecto: ${i?.message}`)
};

const zh_cn2_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目同步失败：${i?.message}`)
};

const ja_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトの同期に失敗しました: ${i?.message}`)
};

const hi_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सिंक विफल: ${i?.message}`)
};

const pt_pt2_team_sync_failed = /** @type {(inputs: Team_Sync_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha na sincronização do projeto: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Project sync failed: {message}" |
*
* @param {Team_Sync_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_failed = /** @type {((inputs: Team_Sync_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_failed(inputs)
	if (locale === "de") return de_team_sync_failed(inputs)
	if (locale === "it") return it_team_sync_failed(inputs)
	if (locale === "ru") return ru_team_sync_failed(inputs)
	if (locale === "es") return es_team_sync_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_failed(inputs)
	if (locale === "ja") return ja_team_sync_failed(inputs)
	if (locale === "hi") return hi_team_sync_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_failed(inputs)
	return en_team_sync_failed(inputs)
});